import React from 'react';
import Swal from "sweetalert2";


import * as commonFunc from 'scripts/common';

import { useTranslation } from "react-i18next";

import {
    Col, Label
} from "reactstrap";
import CGridstack, { CGridStackItem } from 'components/CGridstack';

export default function CategoryFrag(props) {
    const { data, modelFctManager, parentProps, isConfiguration, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };

    const [collapsed, setCollapsed] = React.useState((data.collapsable && data.defaultCollapsed) || false);
    const [shouldRender, setShouldRender] = React.useState(false);


    /*React.useEffect(() => {
        if ((!data.headers || data.headers.length === 0) && modelFctManager && modelFctManager.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);*/

    //useEffect sur props pour trigger APRES le render du composant
    React.useEffect(() => {
        data.childRendered = 0;
        if (isConfiguration && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!isConfiguration && modelFctManager && modelFctManager.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = (forceChild) => {
        setShouldRender(!shouldRender);
        if (forceChild) {
            data.headers.forEach((child) => {
                child?.functionManager?.rerender(true);
            });
        }
    };

    var childs = [];
    if (data.headers) {
        childs = data.headers.map((child) => {
            var childRender = modelFctManager.componentTyped(child, { parentData: data, childs: data.headers, parentDisabled: (parentDisabled || data.disabled ? true : false) });

            if (isConfiguration && !child.gridWidth) {
                var design = child.mergedDesign || child.customDesign?.design;
                var wSize = 1;
                if (design) {
                    wSize = design.boxSize || 1;
                }
                child.gridWidth = Math.round(parseFloat(wSize) * 12);
            }
            return childRender;
        });
    }
    data.childCount = childs.length;

    var icon = "";

    function renderTitle(titleWidthClass, titleWidthStyle) {
        var design = data.customDesign ? data.customDesign.designTitle : null;
        if (!design) design = {}
        var position = design.position;
        if (!position) position = "left";

        var titleModel = <div className={`${titleWidthClass} ${isConfiguration ? "mt-3" : ""} ${data.childless ? "d-none" : ""}`} style={titleWidthStyle} data-backimage={titleWidthStyle.hasImage || null} data-imageOpacity={titleWidthStyle.alpha || null}>
            {design.icon ? <i className="fa fa-user ms-2" style={{ minWidth: "25px" }}></i> : ""}
            {icon}
            <Label className={`m-0 ms-2`}>{altT(data.title)}</Label>
            {data.collapsable ? (collapsed ? <i className="fa fa-chevron-right float-end me-2 mt-1" onClick={() => setCollapsed(!collapsed)}></i> : <i className="fa fa-chevron-down float-end me-2 mt-1" onClick={() => setCollapsed(!collapsed)}></i>) : ""}
        </div>;

        if (!commonFunc.isBlank(data.title)) return titleModel;
        else return "";
    }


    var frameClass = "w-100";
    var frameStyle = { minHeight: "50px" };
    var childStyle = {};
    var childClass = "";
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    var titleWidthClass = "px-0 ps-2 ";
    var titleWidthStyle = { color: "rgb(37, 36, 34)" };
    var iconStyle = {};

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_category");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            frameClass = frameClass.replace("w-100", "");
            frameClass += modelFctManager.manageBoxSize("category-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
        }
        Object.assign(frameStyle, modelFctManager.setCustomBackground(design, data));
        Object.assign(frameStyle, modelFctManager.managePadding(design, frameClass));
        Object.assign(frameStyle, modelFctManager.manageMargin(design, frameClass));// /!\ confusion avec système col ???

        if (design.elevation) {
            frameStyle.boxShadow = design.elevation + " " + design.elevation + " 5px rgba(0,0,0,.15)";
        }


        if (design.width) {
            if (parseFloat(design.width.replace("px", "")) >= 0) frameStyle.width = design.width;
            else {
                frameClass += " w-100";
            }
            frameStyle.overflowX = "hidden";//auto
            //frameClass += " m-0";
        }
        if (design.height) {
            if (parseFloat(design.height.replace("px", "")) >= 0) frameStyle.height = design.height;
            else {
                frameClass += " h-100";
                childClass += " h-100";
            }
            frameStyle.overflowY = "hidden";//auto
            //frameClass += " m-0";
        }
    }
    var designTitle = data.customDesign?.designTitle;
    designTitle = modelFctManager.prepareMergedDesign(data, designTitle, "default_categoryTitle", true);
    if (designTitle) {
        Object.assign(titleWidthStyle, modelFctManager.setCustomBackground(designTitle, data));
        Object.assign(titleWidthStyle, modelFctManager.managePadding(designTitle, titleWidthClass));
        Object.assign(titleWidthStyle, modelFctManager.manageMargin(designTitle, titleWidthClass));

        if (designTitle.elevation) {
            titleWidthStyle.boxShadow = designTitle.elevation + " " + designTitle.elevation + " 5px rgba(0,0,0,.15)";
        }

        if (designTitle.size || designTitle.width) titleWidthStyle.width = (designTitle.size ? (designTitle.size + "px") : designTitle.width);
        if (designTitle.height) titleWidthStyle.height = designTitle.height;

        if (designTitle.fontColor) titleWidthStyle.color = modelFctManager.getRgbaFromHex(designTitle.fontColor);
        if (designTitle.fontSize) titleWidthStyle.fontSize = designTitle.fontSize;
        if (designTitle.fontStyle) {
            if (designTitle.fontStyle.indexOf("bold") >= 0) titleWidthStyle.fontWeight = "bold";
            if (designTitle.fontStyle.indexOf("italic") >= 0) titleWidthStyle.fontStyle = "italic";
        }

        if (designTitle.alignment) {
            var split = designTitle.alignment.split("|");
            split.forEach((part) => {
                titleWidthClass += " text-" + part.replace("left", "start").replace("right", "end");
                titleWidthClass = titleWidthClass.replace("text-top", "align-self-start").replace("text-bottom", "align-self-end");
            });
        }
    }
    var designIcon = data.customDesign?.designIcon;
    designIcon = modelFctManager.prepareMergedDesign(data, designIcon, "default_headerIcon", true);
    if (designIcon) {
        Object.assign(iconStyle, modelFctManager.setCustomBackground(designIcon, data));
        Object.assign(iconStyle, modelFctManager.managePadding(designIcon, titleWidthClass));
        Object.assign(iconStyle, modelFctManager.manageMargin(designIcon, titleWidthClass));

        if (designIcon.fontColor) iconStyle.color = modelFctManager.getRgbaFromHex(designIcon.fontColor);
        if (designIcon.fontSize) iconStyle.fontSize = designIcon.fontSize;
        if (designIcon.fontStyle) {
            if (designIcon.fontStyle.indexOf("bold") >= 0) iconStyle.fontWeight = "bold";
            if (designIcon.fontStyle.indexOf("italic") >= 0) iconStyle.fontStyle = "italic";
        }

        if (designIcon.icon) icon = <i className={`fa ${designIcon.icon.replace(/_/g, "-")} me-2`} style={iconStyle} data-backimage={iconStyle.hasImage || null} data-imageOpacity={iconStyle.alpha || null}></i>;
    }

    //TODO : errorSystem
    var designInput = data.customDesign?.designInput;
    designInput = modelFctManager.prepareMergedDesign(data, designInput, "default_categoryInput", true);
    if (designInput) {
        Object.assign(childStyle, modelFctManager.managePadding(designInput, childClass));
    }

    if (isConfiguration && !data.gridID) data.gridID = Math.floor(Math.random() * 1000000000);

    //return <Col data-name="CategoryFrag" data-element={data.objType} xs="auto" className={`${frameClass}`} style={frameStyle}>{childs}</Col>;
    return isConfiguration ? <Col data-name="CategoryFrag" data-element={data.objType} className={`${frameClass}`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageOpacity={frameStyle.alpha || null}>
        {renderTitle(titleWidthClass, titleWidthStyle)}
        <CGridstack data={childs.map((child, index) => {
            var width = 12;
            var item;
            if (data.headers) {
                item = data.headers[index];
                if (item && item.gridWidth) width = item.gridWidth;
            }
            return { children: child, id: "header-" + data.gridID + "-" + (item?.key || index), srcData: item, noCard: true, x: (index > 0 ? width : 0), y: index * 4, w: width/*, h: 4*/, sizeToContent: true };
        })} type={"category"} srcData={data} configModel={null} isConfigurationMode={true} withRemove={true} noOneColumn={true} defaultState={true} className={`${childClass} ${collapsed ? "d-none" : ""}`} style={childStyle} target={`grid-stack-category-${data.gridID}`} gridClass={"grid-stack-nested"} actionsClass={"text-secondary"} gridOpts={{ cellHeight: 50, sizeToContent: true, acceptWidgets: ".grid-header, .grid-stack-category > .grid-stack-item" }} triggerClick={(grid, dataItem) => { modelFctManager.setSelected(grid, dataItem); }}
            onDropped={(event, prevNode, n) => {
                modelFctManager.dropManager(data, event, prevNode, n);
                setShouldRender(!shouldRender);
            }}/>
    </Col>
        : <Col data-name="CategoryFrag" data-element={data.objType} xs="auto" className={`${frameClass}`} style={frameStyle} data-backimage={frameStyle.hasImage || null} data-imageOpacity={frameStyle.alpha || null}>
            {renderTitle(titleWidthClass, titleWidthStyle)}
            <div className={`${childClass} ${collapsed ? "d-none" : ""}`} style={childStyle}>{childs}</div>
        </Col>;

}